import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取所有会员信息
 * @param {} params 
 * {}
 */
export function getStudentInfo(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/getStudentInfo',
      method: 'post',
      data:postData
    })
  }
  
  export function addStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/addStudent',
      method: 'post',
      data:postData
    })
  }
  
  export function updateStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/editStudent',
      method: 'post',
      data:postData
    })
  }
  
  export function deleteStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/deleteStudent',
      method: 'post',
      data:postData
    })
  }
  
  export function batchDeleteStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/batchDeleteStudent',
      method: 'post',
      data:postData
    })
  }
  //学生回收站列表
  export function getStudentInfoRecycle(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/getStudentInfoRecycle',
      method: 'post',
      data:postData
    })
  }
  //恢复学生
  export function recoverStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/recoverStudent',
      method: 'post',
      data:postData
    })
  }

  //导出学生
  export function excelDownloadStudents(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/file/excelDownloadStudents',
      method: 'post',
      data:postData,
      responseType: 'blob'
    })
  }

  //导出两周无约课学生
  export function excelDownloadTwoMonthStudents(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/file/excelDownloadTwoMonthStudents',
      method: 'post',
      data:postData,
      responseType: 'blob'
    })
  }

  //批量禁止学员接收短信接口
  export function batchUnSendStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/batchUnSendStudent',
      method: 'post',
      data:postData
    })
  }

  //批量恢复学员接收短信接口
  export function batchSetSendStudent(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/student/batchSetSendStudent',
      method: 'post',
      data:postData
    })
  }